import React from 'react';

import { AssetsLoading } from '../../../AssetsLoading';
import { AssetEndOfList } from '../AssetEndOfList';

export interface ListBottomProps {
  hasData: boolean;
  hasNextPage: boolean;
  isLoading: boolean;
  isLoadingMore: boolean;
  ProductItemLoading: React.FC;
}

export const ListBottom: React.FC<ListBottomProps> = ({
  hasData,
  hasNextPage,
  isLoading,
  isLoadingMore,
  ProductItemLoading,
}) => {
  if (!isLoading && !isLoadingMore && !!hasData && !hasNextPage) {
    return <AssetEndOfList />;
  }

  if (hasData || !!isLoadingMore) {
    return <AssetsLoading ProductItemLoading={ProductItemLoading} />;
  }

  return <></>;
};
